<template>
  <div>
    <div v-if="selected">
      <v-card elevation="0">
        <v-card
          elevation="0"
          max-height="200"
          class="overflow-auto scroll"
        >
          <v-card-text class="px-10 pb-0">
            <span class="text-subtitle-2">
              <small>{{ $t('calendar.selectedHour.event') }}</small>
            </span>
            <h4>{{ selected.event.name }}</h4>
          </v-card-text>
          <v-card-text
            class="px-10"
            v-if="selected.event.description"
          >
            <span class="text-subtitle-2">
              <small>{{ $t('calendar.selectedHour.description') }}</small>
            </span>
            <h4>{{ selected.event.description }}</h4>
          </v-card-text>
        </v-card>
        <v-card
          elevation="0"
          class="pa-0 mt-2 mb-5 d-flex justify-center"
        >
          <v-card-text
            class="py-2 px-6 grey lighten-4"
            style="width: 90%;"
          >
            <h3 class="mb-2 font-weight-black black--text">
              {{ $t('calendar.selectedHour.when') }}
            </h3>
            <h4 class="firstLetter">
              <p class="mb-0">
                {{ $ocularMoment.timeZoneDate(selected.hour).format(`dddd, Do [${$t('calendar.selectedHour.of')}] MMMM, HH:mm`) }}
              </p>
              <span class="text-subtitle-2">
                <small>
                  {{ $t('calendar.selectedHour.duration') }}: {{ `${selected.event.duration.value} ` + $t('calendar.selectedHour.minutes') }}
                </small>
              </span>
            </h4>
          </v-card-text>
        </v-card>
      </v-card>
      <div class="actions px-5 pb-5 text-right">
        <v-btn
          v-if="btnPrimaryConfig.data"
          :color="btnPrimaryConfig.data.btn"
          :style="`color: ${btnPrimaryConfig.data.text}`"
          rounded
          large
          block
          @click="$refs.confirm.toggleConfirm()"
          :loading="$store.state.calendar.scheduledEvents.loading"
        >
          {{ $t('calendar.selectedHour.confirm') }}
        </v-btn>
      </div>
      <Confirm
        ref="confirm"
        :title="$t('calendar.confirmModal.title')"
        :detail="$t('calendar.confirmModal.detail')"
        :action="$t('calendar.confirmModal.action')"
        @confirmHandler="schedule"
      />
    </div>
    <Empty
      v-else
      class="px-5 py-5"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import CityMap from '@/plugins/city-map/Index'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

require('@/plugins/OcularMoment')

@Component({
  components: {
    Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty.vue'),
    Confirm: () => import(/* webpackPrefetch: true */ '@/components/Confirm.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    selected: {
      type: Object,
      default: null
    }
  },
  watch: {
    '$store.state.calendar.scheduledEvents.loading': function (loading) {
      if (!loading) {
        this.scheduledEventResponse()
      }
    }
  },
  computed: {
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    }
  }
})
export default class SelectedHour extends Vue {
  data () {
    return {
      loading: false
    }
  }

  back () {
    const parent = this.$parent.$parent.$parent.$parent.$parent
    parent.setStep(1)
    parent.$refs['available-hours'].getHours()
  }

  mounted () {
    this.ocGoogleAnalyticsInit()
  }

  scheduledEventResponse () {
    const alert = {
      color: 'error',
      message: this.$t('calendar.alert.error')
    }

    const error = this.$store.state.calendar.scheduledEvents.error
    const res = this.$store.state.calendar.scheduledEvents.response

    // SUCCESS
    if (error) {
      this.$store.commit('notify', alert)
      this.back()
    } else if (res && res.statusCode === 0) {
      const { data } = res.data
      this.$widget.emitEvent('scheduled-success', data)

      alert.message = this.$t('calendar.alert.scheduled')
      alert.color = 'success'

      this.$router.replace({
        path: '/thank-you-page',
        query: {
          scheduling: true,
          guestReceiveInvitation: res.data.guestReceiveInvitation
        }
      })
    } else if (res) {
      if (res.statusCode === 4) {
        alert.message = this.$t('calendar.alert.sorry')
        alert.color = 'warning'
      } else if (res.statusCode === 10) {
        alert.message = this.$t('calendar.alert.rejectedScheduling')
        alert.color = 'warning'
      }
      this.back()
    }

    this.$store.commit('notify', alert)
  }

  schedule () {
    this.$store.state.calendar.scheduledEvents.response = null
    this.$store.state.calendar.scheduledEvents.error = null
    this.$store.state.calendar.scheduledEvents.loading = true

    const params = {
      date: this.$store.state.calendar.availableHours.date,
      startAt: this.selected.hour,
      eventId: this.selected.event.id,
      scheduleAvailableId: this.selected.schedule_available_id,
      timeZone: this.$widget.getDevice().timeZone
    }

    const customer = this.$store.state.storage.room.customer
    if (customer) {
      params.guestName = customer.name ? customer.name : '',
      params.guestEmail = customer.email ? customer.email : '',
      params.guestPhone = customer.cellphone ? `${customer.countryCode}${customer.cellphone}` : '',
      params.guestTimeZoneOrigin = CityMap.country.offset !== null ? CityMap.country.offset : CityMap.country.timezone,
      params.guestExternalId = this.$store.state.storage.form.code
    }

    if (this.$organization.parentLocation.organizationCode) {
      params.organizationCode = this.$organization.parentLocation.organizationCode
    }

    if (this.$store.state.storage?.category?.id) {
      params.categoryId = this.$store.state.storage.category.id
    }

    this.$calendar.storeScheduledEvent(params)
    this.ocGoogleAnalyticsConfirmModal()
  }

  toggleConfirm () {
    this.$refs.confirm.toggleConfirm()
    this.ocGoogleAnalyticsConfirmReservation()
  }

  ocGoogleAnalyticsInit () {
    OcGoogleAnalytics.getDataLayerConfig('selected.hour')
  }

  ocGoogleAnalyticsConfirmReservation () {
    OcGoogleAnalytics.getDataLayerConfig('confirm.reservation')
  }

  ocGoogleAnalyticsConfirmModal () {
    OcGoogleAnalytics.getDataLayerConfig('confirm.modal')
  }
}
</script>

<style>
/* Tamaño del scroll */
.scroll::-webkit-scrollbar {
  width: 4px;
}

 /* Estilos barra (thumb) de scroll */
.scroll::-webkit-scrollbar-thumb {
  background: #b3b3b3;
  border-radius: 4px;
}

.scroll::-webkit-scrollbar-thumb:active {
  background-color: #999999;
}
.firstLetter p::first-letter{
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
